<div class="footer-content">
    <mat-icon>phone_iphone</mat-icon>
    <span class="adjust-txt-top"> +91 88844 55596</span> &nbsp;&nbsp;&nbsp;
    <mat-icon>mail_outline</mat-icon><a href="mailto: support@kiksarvr.com" class="hyper-link adjust-txt-top"> support@kiksarvr.com</a>
</div>